import LoyaltySettingsCard from "pages/settings/LoyaltySettingsCard";

// Pengaturan -> Sistem Reward -> Loyalty Card, reached from a tile on the
// Pengaturan launcher. Open to any Admin since 2026-08-20; the config
// endpoints' Manager gate was lifted to match. The card renders the page
// heading itself, because the program status and its turn-off action sit
// there.
const LoyaltyProgramPage = () => <LoyaltySettingsCard />;

export default LoyaltyProgramPage;
